import React from 'react';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWarning } from "@fortawesome/free-solid-svg-icons";

const alertType = {
  warning: {
    icon: faWarning,
    headerText: "Warning",
    headerClass: "text-orange-800",
    iconClass: "text-orange-500",
    bgClass: "bg-orange-50",
    borderClass: "border-orange-200",
  }
}

interface AlertBoxProps {
  icon?: any;
  type?: keyof typeof alertType;
  headerText?: string;
  children?: React.ReactNode;
}

const AlertBox = ({
  icon,
  type = "warning",
  headerText,
  children
}: AlertBoxProps) => {
  const { icon: typeIcon, headerText: typeHeaderText, headerClass, iconClass, bgClass, borderClass } = alertType[type] || {};
  
  return (
    <div className={`${bgClass} border ${borderClass} rounded-lg p-4 mb-4`}>
      <div className={`flex items-center space-x-2 ${headerClass} font-medium`}>
        <FontAwesomeIcon
          className={`${iconClass} text-lg pr-2`}
          icon={icon || typeIcon}
        />{" "}
        {headerText || typeHeaderText}
      </div>
      <div className="text-gray-600 text-sm mt-2 mb-0">
        {children}
      </div>
    </div>
  );
};

export default AlertBox;